import { render, staticRenderFns } from "./StepImporting.vue?vue&type=template&id=023f8b36&scoped=true"
import script from "./StepImporting.vue?vue&type=script&lang=js"
export * from "./StepImporting.vue?vue&type=script&lang=js"
import style0 from "./StepImporting.vue?vue&type=style&index=0&id=023f8b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f8b36",
  null
  
)

export default component.exports